var map = {
	"./auto.svg": 78044,
	"./bin.svg": 18228,
	"./bin2.svg": 69862,
	"./book.svg": 71646,
	"./briefcase.svg": 39725,
	"./calendar-30.svg": 41591,
	"./circle-percent.svg": 19387,
	"./ellipsis-v.svg": 54131,
	"./euro.svg": 35950,
	"./files.svg": 86714,
	"./image.svg": 26012,
	"./key.svg": 73546,
	"./magnifier.svg": 83365,
	"./money-sheet.svg": 62415,
	"./money.svg": 81021,
	"./multiple-cards.svg": 92993,
	"./payment-terminal.svg": 45966,
	"./pen.svg": 23358,
	"./piggy_bank.svg": 14900,
	"./setting.svg": 52741,
	"./sign.svg": 76974,
	"./time-flies.svg": 34274,
	"./user.svg": 11028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90097;